// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WIKI_ARTICLE_REVIEWED_BY = "Text po odbornej str\u00e1nke skontroloval(a):";
export const WIKI_ARTICLE_REVIEWED_BY_FEMALE = "Text po odbornej str\u00e1nke skontrolovala:";
export const WIKI_ARTICLE_REVIEWED_BY_MALE = "Text po odbornej str\u00e1nke skontroloval:";
